export class SessionTracker {

    constructor(private sessionParam: number) {
        if (!this.sessionParam) {
            this.sessionParam = 0;
        }
    }

    public reloadIfSessionParamMismatch(sessionParamFromServer: number): void {
        this.sessionParam++;
        if (this.sessionParam !== sessionParamFromServer) {
            window.location.reload(false);
        }
    }
}



// WEBPACK FOOTER //
// ./src/SessionTracker.ts